import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { CDate } from "../common/CapitalDate";
const StatementsList = ({ statements }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rows = statements.map((item) => item);
    const columns = [
        {
            field: "number",
            headerName: "Number",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => (_jsx("a", { href: generateStatementLink(params.row), target: "_blank", rel: "noreferrer", children: params.row.Number })),
        },
        {
            field: "account",
            headerName: "Account",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => params.row.AccountNumber,
        },
        {
            field: "from",
            headerName: "From",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => _jsx(CDate, { date: params.row.PeriodFrom }),
        },
        {
            field: "to",
            headerName: "To",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => _jsx(CDate, { date: params.row.PeriodTo }),
        },
    ];
    return (_jsxs("section", { className: "sub-wrap", children: [_jsx("h2", { children: "Statements" }), _jsx(DataGridPro, { rows: rows, columns: columns, getRowId: (r) => r.Id, pageSizeOptions: [10, 25, 50], pagination: true, initialState: {
                    sorting: {
                        sortModel: [{ field: "date", sort: "desc" }],
                    },
                    pagination: {
                        paginationModel: { pageSize: 10 },
                    },
                } })] }));
};
const generateStatementLink = (statement) => {
    return `/api/statements/${statement.InstrumentId}/documents/${statement.FileId}`;
};
export default StatementsList;
